import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getAuthUser, isAuthenticated } from "../../../utils/auth";
import { sessionRestored } from "../../containers/Login/slice";

export default function RequireAuth() {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const stored = getAuthUser();
    if (stored) {
      dispatch(sessionRestored({ ...stored, token: "" }));
    }
  }, [dispatch]);

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
